module.exports = __webpack_public_path__ + "static/img/865-1.8e37add.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/psLock/865/865-1.jpg
// module id = GnQw
// module chunks = 0